export default {
  // Portal Root checks these api urls for health
  // Redis has its own health logic and is not included here
  api: {
    paywall: `${process.env.PAYWALL_API_URL_SERVER}/health_check`,
    content: `${process.env.CONTENT_API_URL_SERVER}/health_check`,
    login: `${process.env.LOGIN_API_URL_SERVER}/health_check`,
    pcc: `${process.env.PCC_API_URL_SERVER}/swagger.json`,
  },
  // Portal Root checks these services for health
  // NB! Correct types have to added to typings when adding new services to check
  servicesToCheck: ['paywall', 'login', 'content-api-v3'],
};
